import { ErrorMessages, ProductInfoComponent, ProductType } from '@inter-ikea-storageone/range';
import { BehaviorParameters } from 'rangeConfig/@types';
import { hideNoFramesInSceneErrorMessage } from 'rangeConfig/shared/rules/hideMenuRules';

const addInterior = ({ coreApi, props, rootState }: BehaviorParameters) => {
  const productId = props.coreProductIds ? props.coreProductIds[0] : props.coreProductId;

  const interiorProduct = rootState.products.inMarket.find(
    product => product.coreProductId == productId
  );

  const placementResult = coreApi.products.add(productId, props.position);
  if (!placementResult.valid && placementResult.errors && placementResult.errors.length > 0) {
    const determinePlacementAttemptErrorMessage = () => {
      if (!hideNoFramesInSceneErrorMessage(coreApi)) {
        return ErrorMessages.NoFramesInScene;
      } else if (
        interiorProduct?.type === ProductType.BILLY_DESK ||
        interiorProduct?.type === ProductType.BILLY_DRAWER
      ) {
        const doorCollision = placementResult.errors.find((e: any) =>
          e.collisions?.find((c: any) => {
            const isDoor =
              c.other.getComponent(ProductInfoComponent.id)?.productType === ProductType.BILLY_DOOR;
            return isDoor;
          })
        );
        if (doorCollision) {
          return ErrorMessages.BillyInteriorCollidesWithDoor;
        } else {
          return ErrorMessages.ItemWontFit;
        }
      }
      return null;
    };
    const placementAttemptErrorMessage = determinePlacementAttemptErrorMessage();
    if (placementAttemptErrorMessage) {
      coreApi.emit.onPlacementAttempt(placementAttemptErrorMessage);
    }
    coreApi.entities.disposeCollidingEntities(placementResult.errors);
  }
};

export default addInterior;
